(() => {
  const modal = document.querySelector('[data-klarna-modal]');
  if (!modal) return;

  const triggers = Array.from(document.querySelectorAll('[data-klarna-modal-open]'));
  const dialog = modal.querySelector('[role="dialog"]');
  const closeSelector = '[data-klarna-modal-close]';
  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  let activeTrigger = null;

  const getFocusable = () => Array.from(modal.querySelectorAll(focusableSelector)).filter((element) => element.offsetParent !== null);

  const openModal = (trigger) => {
    activeTrigger = trigger || document.activeElement;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('elite-modal-open');
    document.body.classList.add('elite-modal-open', 'elite-klarna-modal-open');

    window.requestAnimationFrame(() => {
      const focusTarget = modal.querySelector(closeSelector) || dialog || modal;
      if (focusTarget && typeof focusTarget.focus === 'function') {
        focusTarget.focus({ preventScroll: true });
      }
    });
  };

  const closeModal = () => {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('elite-modal-open');
    document.body.classList.remove('elite-modal-open', 'elite-klarna-modal-open');

    if (activeTrigger && typeof activeTrigger.focus === 'function') {
      activeTrigger.focus({ preventScroll: true });
    }

    activeTrigger = null;
  };

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      openModal(trigger);
    });
  });

  modal.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    if (!event.target.closest(closeSelector)) return;

    event.preventDefault();
    closeModal();
  });

  document.addEventListener('keydown', (event) => {
    if (modal.hidden) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusable = getFocusable();
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
